package com.daytimegaming.ourdailyfinances.presentation.account

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.daytimegaming.ourdailyfinances.domain.Response
import com.daytimegaming.ourdailyfinances.domain.model.Transaction
import com.daytimegaming.ourdailyfinances.domain.repository.DashboardRepository
import com.daytimegaming.ourdailyfinances.domain.repository.TransactionRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

sealed class TransactionDetailScreenState {
    data object Loading : TransactionDetailScreenState()
    data class Error(val message: String) : TransactionDetailScreenState()
    data class Loaded(val transaction: Transaction) : TransactionDetailScreenState()
}

class TransactionDetailViewModel(
    private val transactionId: String,
    private val dashboardId: String?,
    private val transactionRepository: TransactionRepository,
    private val dashboardRepository: DashboardRepository
) : ViewModel() {

    private val _state = MutableStateFlow<TransactionDetailScreenState>(TransactionDetailScreenState.Loading)
    val state = _state.asStateFlow()

    init {
        load()
    }

    fun load() {
        _state.value = TransactionDetailScreenState.Loading
        viewModelScope.launch {
            if (dashboardId != null) {
                dashboardRepository.getDashboardDetail(dashboardId).collect { response ->
                    when (response) {
                        is Response.Loading -> {
                            _state.value = TransactionDetailScreenState.Loading
                        }
                        is Response.Error -> {
                            _state.value = TransactionDetailScreenState.Error(response.message)
                        }
                        is Response.Success -> {
                            val transaction = response.data.transactions.find { it.transactionId == transactionId }
                            if (transaction != null) {
                                _state.value = TransactionDetailScreenState.Loaded(transaction)
                            } else {
                                _state.value = TransactionDetailScreenState.Error("Transaction not found.")
                            }
                        }
                    }
                }
            } else {
                transactionRepository.transactions.collect { response ->
                    when (response) {
                        is Response.Loading -> {
                            _state.value = TransactionDetailScreenState.Loading
                        }
                        is Response.Error -> {
                            _state.value = TransactionDetailScreenState.Error(response.message)
                        }
                        is Response.Success -> {
                            val transaction = response.data.find { it.transactionId == transactionId }
                            if (transaction != null) {
                                _state.value = TransactionDetailScreenState.Loaded(transaction)
                            } else {
                                _state.value = TransactionDetailScreenState.Error("Transaction not found.")
                            }
                        }
                    }
                }
            }
        }
    }

    fun updateCategory(detailedCategory: String?) {
        viewModelScope.launch {
            val result = transactionRepository.updateTransactionCategory(transactionId, detailedCategory)
            if (result is Response.Success) {
                _state.value = TransactionDetailScreenState.Loaded(result.data)
            }
        }
    }
}
